import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IIndicatorsReportRequest } from "../interface/report/IIndicatorsReportRequest";
import { IIndicatorsReportResponse } from "../interface/report/IIndicatorsReportResponse";

enum reportIndicatorsServiceEnum {
    getAll = "/",
}

export default class ReportIndicatorsService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/report/indicators");
    }

    public getAll = async (data: IIndicatorsReportRequest): Promise<IIndicatorsReportResponse[]> => await this.POST(reportIndicatorsServiceEnum.getAll, data);

}


// WEBPACK FOOTER //
// ./src/services/api/ReportIndicators.service.ts